import { useState, FormEvent } from 'react'
import TextField from '@mui/material/TextField'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import IconButton from '@mui/material/IconButton'
import { useAuth } from '../App'
import AuthLayout from '../components/AuthLayout'
import { inputSx, primaryButtonSx } from '../styles/authSx'

import { Link } from 'react-router-dom'
import Visibility from '@mui/icons-material/Visibility'
import VisibilityOff from '@mui/icons-material/VisibilityOff'
import { InputAdornment } from '@mui/material'

const Home = () => {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [showPassword, setShowPassword] = useState(false)
  const [submitting, setSubmitting] = useState(false)
  const auth = useAuth()

  const canSubmit = email.length > 0 && password.length > 0 && !submitting

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault()
    if (!canSubmit) return
    setSubmitting(true)
    try {
      await auth?.signIn(email, password)
    } finally {
      setSubmitting(false)
    }
  }

  return (
    <AuthLayout
      title="Sign in"
      subtitle="Use your Voxist account to continue."
    >
      <Box component="form" noValidate onSubmit={handleSubmit}>
        <TextField
          fullWidth
          id="email"
          name="email"
          label="Email"
          type="email"
          autoComplete="email"
          autoFocus
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          sx={inputSx}
        />

        <TextField
          fullWidth
          id="password"
          name="password"
          label="Password"
          type={showPassword ? 'text' : 'password'}
          autoComplete="current-password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          sx={inputSx}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  aria-label={
                    showPassword ? 'Hide password' : 'Show password'
                  }
                  onClick={() => setShowPassword((v) => !v)}
                  edge="end"
                  size="small"
                  tabIndex={-1}
                  sx={(t) => ({
                    color:
                      t.palette.mode === 'dark' ? '#FFFFFF99' : '#6E6E73'
                  })}
                >
                  {showPassword ? (
                    <VisibilityOff fontSize="small" />
                  ) : (
                    <Visibility fontSize="small" />
                  )}
                </IconButton>
              </InputAdornment>
            )
          }}
        />

        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
            mt: 0.5,
            mb: 2
          }}
        >
          <Link
            to="/resetLink"
            style={{
              textDecoration: 'none',
              color: '#00A3C4',
              fontSize: '0.8125rem',
              fontWeight: 700
            }}
          >
            Forgot password?
          </Link>
        </Box>

        <Button
          type="submit"
          fullWidth
          variant="contained"
          disableElevation
          disabled={!canSubmit}
          sx={(t) => ({ ...primaryButtonSx(t), mt: 1 })}
        >
          {submitting ? 'Signing in…' : 'Sign in'}
        </Button>
      </Box>
    </AuthLayout>
  )
}
export default Home
